<template>
  <div>
    <ZipcodeSlideout
      v-if="zipcodeSlideoutShown && activeSlideout === productId"
      :id="productId"
      v-model:zip-code="zipCode"
      :page="page"
      @update:zip-code="onUpdateZipcode"
      @closed:zip-code="onSlideoutClose"
    />
  </div>
</template>

<script setup>
import ZipcodeSlideout from '@nuxt-common/fulfillment/app/components/zipcode/ZipcodeSlideout';
import { nextTick } from 'vue';
import { useProduct } from '~/modules/product/composables/useProduct';
import { useAvailabilityBigTicket } from '~/modules/availability/composables/useAvailabilityBigTicket';
import { useFulfilmentData } from '~/modules/availability/composables/useFulfilmentData';

const { zipCode } = useFulfilmentData();
const { productId } = useProduct();
const page = 'pdp';

const { zipcodeSlideoutShown, previouslyFocusedElement, setStoreZipCode, activeSlideout } = useAvailabilityBigTicket();

/** @param {string} slideoutZipCode */
const onUpdateZipcode = (slideoutZipCode) => {
  setStoreZipCode(slideoutZipCode);
  zipcodeSlideoutShown.value = false;
  activeSlideout.value = false;
};

const onSlideoutClose = async () => {
  zipcodeSlideoutShown.value = false;
  activeSlideout.value = false;
  await nextTick();
  previouslyFocusedElement.value?.focus();
};
</script>
